import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {PostDO} from '../../common/data-objects/PostDO';

@Component({
  selector: 'app-cartoon-thumbnail',
  templateUrl: './cartoon-thumbnail.component.html',
  styleUrls: ['./cartoon-thumbnail.component.scss']
})
export class CartoonThumbnailComponent implements OnInit, OnChanges {
  @Input() post: PostDO;
  maxTags: string[];
  MAX_TAGS_COUNT = 4;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.video) {
      this.maxTags = this.post.tags.splice(0, this.MAX_TAGS_COUNT);
    }
  }

  getImageUrl(post): string {
    return post.featuredImageSizes ? post.featuredImageSizes.medium : null;
  }

  get postLink(): string[] {
    return [this.post.slug];
  }
}
